/**
 * OEBAK-Teilnehmer
 * REST-Endpoints fuer Teilnehmer-Applikation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KursInfoVO } from './kursInfoVO';


export interface KursInfoTeilnehmerVO { 
    zertifizierungstyp: KursInfoTeilnehmerVO.ZertifizierungstypEnum;
    kursGutachterTaetigkeit?: Set<KursInfoTeilnehmerVO.KursGutachterTaetigkeitEnum>;
    rechnungName?: string;
    rechnungEmail?: string;
    rechnungStrasse?: string;
    rechnungPostleitzahl?: string;
    rechnungOrt?: string;
    lieferName?: string;
    lieferEmail?: string;
    lieferStrasse?: string;
    lieferPostleitzahl?: string;
    lieferOrt?: string;
    platzKontingent?: KursInfoTeilnehmerVO.PlatzKontingentEnum;
    kurs: KursInfoVO;
    bestaetigungAGB?: boolean;
    bestaetigungDatenschutz?: boolean;
    bestaetigungTraeger?: boolean;
}
export namespace KursInfoTeilnehmerVO {
    export type ZertifizierungstypEnum = 'ZERTIFIZIERUNG' | 'REZERTIFIZIERUNG';
    export const ZertifizierungstypEnum = {
        ZERTIFIZIERUNG: 'ZERTIFIZIERUNG' as ZertifizierungstypEnum,
        REZERTIFIZIERUNG: 'REZERTIFIZIERUNG' as ZertifizierungstypEnum
    };
    export type KursGutachterTaetigkeitEnum = 'KEINE' | 'AUVA' | 'BVAEB' | 'PVA' | 'SVS';
    export const KursGutachterTaetigkeitEnum = {
        KEINE: 'KEINE' as KursGutachterTaetigkeitEnum,
        AUVA: 'AUVA' as KursGutachterTaetigkeitEnum,
        BVAEB: 'BVAEB' as KursGutachterTaetigkeitEnum,
        PVA: 'PVA' as KursGutachterTaetigkeitEnum,
        SVS: 'SVS' as KursGutachterTaetigkeitEnum
    };
    export type PlatzKontingentEnum = 'OEGKV' | 'SVTRAEGER' | 'FREI';
    export const PlatzKontingentEnum = {
        OEGKV: 'OEGKV' as PlatzKontingentEnum,
        SVTRAEGER: 'SVTRAEGER' as PlatzKontingentEnum,
        FREI: 'FREI' as PlatzKontingentEnum
    };
}


